module.exports = __webpack_public_path__ + "img/functional2-img4.f23b3ce3.png";